import { getSupabase } from '@/lib/supabase';

export type ClientEvent = {
  id: string;
  client_id: string;
  coach_id: string;
  client_program_id: string;
  type: string;
  summary: string;
  details: any;
  priority: number;
  created_at: string;
  seen_at: string | null;
  dismissed_at: string | null;
};

export async function listClientEvents(limit = 10): Promise<ClientEvent[]> {
  const sb = getSupabase();
  if (!sb) throw new Error('Supabase client not available');
  const { data, error } = await sb
    .from('client_events')
    .select('*')
    .is('dismissed_at', null)
    .order('created_at', { ascending: false })
    .limit(limit);
  if (error) throw error;
  return data || [];
}

export async function markEventsSeen(ids: string[]) {
  if (!ids.length) return;
  const sb = getSupabase();
  if (!sb) throw new Error('Supabase client not available');
  const { error } = await sb
    .from('client_events')
    .update({ seen_at: new Date().toISOString() })
    .in('id', ids)
    .select('id'); // force RLS
  if (error) throw error;
}

export async function dismissEvent(id: string) {
  const sb = getSupabase();
  if (!sb) throw new Error('Supabase client not available');
  const { error } = await sb
    .from('client_events')
    .update({ dismissed_at: new Date().toISOString() })
    .eq('id', id)
    .select('id');
  if (error) throw error;
}

export function subscribeClientEvents(onAnyChange: () => void) {
  const sb = getSupabase();
  if (!sb) return () => {};
  const ch = sb
    .channel('realtime:client_events')
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'client_events',
      },
      () => onAnyChange(),
    )
    .subscribe();
  return () => sb.removeChannel(ch);
}
